var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.numberOfMessages == 1)?_c('div',[_c('single-message-display')],1):_c('div',[_c('message-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }